import React from "react";
import { FaEye, FaLaptopCode, FaChalkboardTeacher } from "react-icons/fa";

const ServiceComponent = () => {
  return (
    <div>
      <div id="service" className="section-padding">
        <div className="container">
          <div className="row">
            <div className="page-title container text-center">
              <h1>Expertise Digital solutions</h1>
              <p>
                Curigma offers you result-driven digital solutions, We have
                hardcore application development specialists to meet your
                quality expectations at your cost.{" "}
              </p>
              <div className="row">
                {" "}
                <hr className="pg-titl-bdr-btm"></hr>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service-box">
                <div className="service-icon">
                  <FaEye />
                </div>
                <div className="service-text">
                  <h3>
                    <b>Design</b>
                  </h3>
                  <p>
                    {" "}
                    Creativity is the only word in our dictionary! That’s why
                    never take a step back in delivering creative design
                    services for industries.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service-box">
                <div className="service-icon">
                  <FaLaptopCode />
                </div>
                <div className="service-text">
                  <h3>
                    <b>Development</b>
                  </h3>
                  <p>
                    Development is what we believe in! We provide Custom Web and
                    software development that enhances your business.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="service-box">
                <div className="service-icon">
                  <FaChalkboardTeacher />
                </div>
                <div className="service-text">
                  <h3>
                    <b>Training</b>
                  </h3>
                  <p>
                    {" "}
                    We bring in advanced industry training that helps you make
                    your way to success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceComponent;
